<template>
  <div>
    <div class="row">
      <div class="col-lg-12">
        <div class="mb-3" style="float: right;">
          <button type="button" v-on:click="openfilter" class="btn btn-warning">
            <i class="fas fa-filter"></i>Filter
          </button>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-4">
        <div class="info-box mb-3 myhover" v-on:click="redirectClients(0)">
          <span class="info-box-icon bg-custom elevation-1">
            <i class="fas fa-notdog fa-solid fa-list text-white"></i>
          </span>
          <div class="info-box-content">
            <span class="info-box-text">New Clients (Last seven days)</span>
            <span class="info-box-number">
              <template v-if="selectedFilter === 'All'">
                <span class="info-box-number">
                  {{ typeof clients === 'number' ? clients.toLocaleString() : 0 }}
                </span>
              </template>
              <template v-if="selectedFilter === 'Count'">
                <span>({{ typeof clients === 'number' ? clients.toLocaleString() : 0 }})</span>
              </template>
            </span>
          </div>
        </div>
      </div>
      <div class="col-lg-4">
        <div class="info-box mb-3 myhover" v-on:click="redirectClients(1)">
          <span class="info-box-icon bg-gradient-success elevation-1">
            <i class="fas fa-solid fa-list-ol text-white"></i>
          </span>
          <div class="info-box-content">
            <span class="info-box-text">No. of Individual Clients</span>
            <span class="info-box-number">
              <template v-if="selectedFilter === 'All'">
                <span class="info-box-number">{{individual.toLocaleString()}}</span>
              </template>
              <template v-if="selectedFilter === 'Count'">
                <span>({{ individual ? individual.toLocaleString() : 0 }})</span>
              </template>
            </span>
          </div>
        </div>
      </div>
      <div class="col-lg-4">
        <div class="info-box mb-3 myhover" v-on:click="redirectClients(2)">
          <span class="info-box-icon bg-gradient-dark elevation-1">
            <i class="fas fa-solid fa-list-ol text-white"></i>
          </span>
          <div class="info-box-content">
            <span class="info-box-text">No. of Corporate Clients</span>
            <span class="info-box-number">
              <template v-if="selectedFilter === 'All'">
                <span class="info-box-number">{{corporate.toLocaleString()}}</span>
              </template>
              <template v-if="selectedFilter === 'Count'">
                <span>({{ corporate ? corporate.toLocaleString() : 0 }})</span>
              </template>
            </span>
          </div>
        </div>
      </div>
      <div class="col-lg-4">
        <div class="info-box mb-3 myhover" v-on:click="openPendingKyc">
          <span class="info-box-icon bg-gradient-secondary elevation-1">
            <i class="fas fa-clock"></i>
          </span>
          <div class="info-box-content">
            <span class="info-box-text">Pending Kyc</span>
            <span class="info-box-number">
              <template v-if="selectedFilter === 'All'">
                <span class="info-box-number">{{pendingkyc.toLocaleString()}}</span>
              </template>
              <template v-if="selectedFilter === 'Count'">
                <span>({{ pendingkyc ? pendingkyc.toLocaleString() : 0 }})</span>
              </template>
            </span>
          </div>
        </div>
      </div>
      <div class="col-lg-4">
        <div class="info-box mb-3 myhover" v-on:click="redirectClientsReport('director')">
          <span class="info-box-icon bg-gradient-danger elevation-1">
            <i class="fas fa-question-circle text-white"></i>
          </span>
          <div class="info-box-content">
            <span class="info-box-text">Expired Director CNIC</span>
            <span class="info-box-number">
              <template v-if="selectedFilter === 'All'">
                <span class="info-box-number">
                  {{ typeof expireddirector === 'number' ? expireddirector.toLocaleString() : '0' }}
                </span>
              </template>
              <template v-if="selectedFilter === 'Count'">
                <span>
                  ({{ typeof expireddirector === 'number' ? expireddirector.toLocaleString() : '0' }})
                </span>
              </template>
            </span>
          </div>
        </div>
      </div>
      <!--<div class="col-lg-4">
        <div class="info-box mb-3 myhover" v-on:click="redirectClientsReport(0)">
          <span class="info-box-icon bg-gradient-blue elevation-1">
            <i class="fas fa-question-circle text-white"></i>
          </span>
          <div class="info-box-content">
            <span class="info-box-text">Expired Beneficiary CNIC</span>
            <span class="info-box-number">
              <template v-if="selectedFilter === 'All'">
                <span class="info-box-number">
                  {{ typeof expiredbenificiary === 'number' ? expiredbenificiary.toLocaleString() : '0' }}
                </span>
              </template>
              <template v-if="selectedFilter === 'Count'">
                <span>
                  ({{ typeof expiredbenificiary === 'number' ? expiredbenificiary.toLocaleString() : '0' }})
                </span>
              </template>
            </span>
          </div>
        </div>
      </div>-->
      <div class="col-lg-4">
        <div class="info-box mb-3 myhover" v-on:click="redirectClientsReport('individual')">
          <span class="info-box-icon bg-gradient-teal elevation-1">
            <i class="fas fa-question-circle text-white"></i>
          </span>
          <div class="info-box-content">
            <span class="info-box-text">Expired Individual CNIC</span>
            <span class="info-box-number">
              <template v-if="selectedFilter === 'All'">
                <span class="info-box-number">
                  {{ typeof expiredindividual === 'number' ? expiredindividual.toLocaleString() : '0' }}
                </span>
              </template>
              <template v-if="selectedFilter === 'Count'">
                <span>
                  ({{ typeof expiredindividual === 'number' ? expiredindividual.toLocaleString() : '0' }})
                </span>
              </template>
            </span>
          </div>
        </div>
      </div>
      <!--<div class="col-lg-4">
        <div class="info-box mb-3 myhover" v-on:click="redirectClientsReport('verification')">
          <span class="info-box-icon bg-gradient-yellow elevation-1">
            <i class="fas fa-light fa-hourglass-half text-white"></i>
          </span>
          <div class="info-box-content">
            <span class="info-box-text">Pending CNIC Verification (By Nadra)</span>
            <span class="info-box-number">
              <template v-if="selectedFilter === 'All'">
                <span class="info-box-number">{{pending_verification.toLocaleString()}}</span>
              </template>
              <template v-if="selectedFilter === 'Count'">
                <span>({{ pending_verification ? pending_verification.toLocaleString() : 0 }})</span>
              </template>
            </span>
          </div>
        </div>
      </div>-->
      <div class="col-lg-4">
        <div class="info-box mb-3 myhover" v-on:click="redirectAdvanceSearch(0)">
          <span class="info-box-icon bg-gradient-maroon elevation-1">
            <i class="fas fa-search text-white"></i>
          </span>
          <div class="info-box-content">
            <span class="info-box-text">Client Advance Search</span>
          </div>
        </div>
      </div>
      <div class="col-lg-4">
        <div class="info-box mb-3 myhover" v-on:click="redirectMatchingBulkClient(0)">
          <span class="info-box-icon bg-gradient-navy elevation-1">
            <i class="fas fa-users text-white"></i>
          </span>
          <div class="info-box-content">
            <span class="info-box-text">Matching Bulk Client</span>
          </div>
        </div>
      </div>
      <div class="col-lg-4">
        <div class="info-box mb-3 myhover" v-on:click="redirectBlockAccountClient(0)">
          <span class="info-box-icon bg-gradient-danger elevation-1">
            <i class="fas fa-ban text-white"></i>
          </span>
          <div class="info-box-content">
            <span class="info-box-text">Block Account Client</span>
          </div>
        </div>
      </div>
      <div class="col-lg-8">

      </div>
    </div>
    <div class="row">
      <div class="col-lg-6">
        <div class="card">
          <div class="card-header bg-gradient-success border-transparent">
            <h3 class="card-title">Individual Clients</h3>
          </div>
          <div class="card-body" style="margin-bottom: 5px;">
            <div :class="tablesWait ? 'overlay-wrapper' : ''">
              <div v-if="tablesWait" class="overlay"><i class="fas fa-2x fa-sync-alt fa-spin"></i></div>
              <div class="table-responsive">
                <table class="table table-sm">
                  <thead>
                    <tr>
                      <th style="text-align:center">Low Risk Clients</th>
                      <th style="text-align:center">Medium Risk Clients</th>
                      <th style="text-align:center">High Risk Clients</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td style="text-align:center">{{ individualCRP.Low.toLocaleString()}}</td>
                      <td style="text-align:center">{{ individualCRP.Medium.toLocaleString()}}</td>
                      <td style="text-align:center">{{ individualCRP.High.toLocaleString()}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div class="card-footer text-center">
            <a href="../UIC/ClientDetails" target="_blank">View Detail</a>
          </div>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="card">
          <div class="card-header bg-gradient-dark border-transparent">
            <h3 class="card-title">Corporate Clients</h3>
          </div>
          <div class="card-body" style="margin-bottom: 5px;">
            <div :class="tablesWait ? 'overlay-wrapper' : ''">
              <div v-if="tablesWait" class="overlay"><i class="fas fa-2x fa-sync-alt fa-spin"></i></div>
              <div class="table-responsive">
                <table class="table table-sm">
                  <thead>
                    <tr>
                      <th style="text-align:center">Low Risk Clients</th>
                      <th style="text-align:center">Medium Risk Clients</th>
                      <th style="text-align:center">High Risk Clients</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td style="text-align:center">{{ corporateCRP.Low.toLocaleString()}}</td>
                      <td style="text-align:center">{{ corporateCRP.Medium.toLocaleString()}}</td>
                      <td style="text-align:center">{{ corporateCRP.High.toLocaleString()}}</td>
                    </tr>

                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div class="card-footer text-center">
            <a href="../UIC/ClientDetails" target="_blank">View Detail</a>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade show" data-backdrop="static" id="dateFilter" aria-modal="true" role="dialog">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header bg-custom">
            <h4 class="modal-title">Filter</h4>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true" class="text-white">×</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-4">
                <div class="form-group">
                  <label>Date From</label>
                  <input type="date" v-model="filter.DateFrom" v-on:input="checkDate" class="form-control" />
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label>Date To</label>
                  <input type="date" v-model="filter.DateTo" v-on:input="checkDate" class="form-control" />
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label>Filter</label>
                  <select v-model="selectedFilter" class="form-control">
                    <option disabled value="">Select</option>
                    <option value="All">All</option>
                    <option value="Count">Count</option>
                    <option value="Value">Value</option>
                    <!--<option value="Count+Value">Count+Value</option>-->
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer justify-content-between">
            <button type="button" class="btn btn-success" v-on:click="applyDateFilter">Apply</button>
            <button type="button" class="btn btn-danger" data-dismiss="modal">Close</button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="pendingKycModal" tabindex="-1" role="dialog" data-backdrop="static">
      <div class="modal-dialog modal-xl" role="document">
        <div class="modal-content">
          <div class="modal-header bg-custom">
            <h4 class="modal-title">Pending KYC Clients ({{ filteredPendingKyc.length.toLocaleString() }})</h4>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true" class="text-white">×</span>
            </button>
          </div>

          <div class="modal-body">
            <div class="row mb-3">
              <div class="col-md-4">
                <input type="text" class="form-control" v-model.trim="pendingKycSearch" placeholder="Search by code or name..." />
              </div>
            </div>

            <div :class="pendingKycLoading ? 'overlay-wrapper' : ''">
              <div v-if="pendingKycLoading" class="overlay"><i class="fas fa-2x fa-sync-alt fa-spin"></i></div>
              <div class="table-responsive" style="max-height:450px;overflow-y:auto;">
                <table class="table table-sm table-bordered table-hover">
                  <thead class="bg-custom" style="position:sticky;top:0;">
                    <tr>
                      <th class="text-center" width="6%">Sr.</th>
                      <th width="16%">Code</th>
                      <th>Name</th>
                      <th width="14%">Client Type</th>
                      <th width="14%">Inserted On</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, ind) in filteredPendingKyc" :key="item.BP_ID">
                      <td class="text-center">{{ ind + 1 }}</td>
                      <td>{{ item.BP_CODE_NEW }}</td>
                      <td>{{ item.BP_DSC }}</td>
                      <td>{{ getClientType(item.PTR_ID) }}</td>
                      <td>{{ formatDate(item.BP_INS_DTE) }}</td>
                    </tr>
                    <tr v-if="!pendingKycLoading && filteredPendingKyc.length === 0">
                      <td colspan="5" class="text-center text-muted">No pending KYC clients found.</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-danger" @click="closePendingKyc">Close</button>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
  const axios = require('axios').default;
  var XLSX = require("xlsx");
  var salesAnalysisChart;
  var topSoldProductsChart;
  var top5CustomersChart;
  var saleModeChart;
  var customerTypeChart;
  export default ({
    data() {
      return {
        clients: 0,
        individual: 0,
        corporate: 0,
        pendingkyc: 0,
        expireddirector: 0,
        //expiredbenificiary: 0,
        expiredindividual: 0,
        //pending_verification: 0,
        BPCRP_RISKISLOW: 0,
        BPCRP_RISKISMEDIUM: 0,
        BPCRP_RISKISHIGH: 0,
        totalShipment: 0,
        totalShippmentValue: 0,
        totalSales: 0,
        bpcrp_list: [],
        individualCRP: { Low: 0, Medium: 0, High: 0 },
        corporateCRP: { Low: 0, Medium: 0, High: 0 },
        riskCounts: [],
        filter: {
          DateFrom: '',
          DateTo: ''
        },
        selectedFilter: 'All',
        tablesWait: false,
        pendingKycList: [],
        pendingKycLoading: false,
        pendingKycSearch: '',
        pendingKycModalInstance: null,
      };
    },
    created: function () {
      this.pageload();
    },
    mounted() {
      const el = document.getElementById('pendingKycModal');
      document.body.appendChild(el);   // avoids stacking/overflow problems
      if (window.bootstrap && bootstrap.Modal) {
        this.pendingKycModalInstance = new bootstrap.Modal(el, { backdrop: 'static', keyboard: false });
      }
    },
    beforeDestroy() {
      const el = document.getElementById('pendingKycModal');
      if (el && el.parentNode === document.body) document.body.removeChild(el);
    },
    computed: {
      filteredPendingKyc() {
        const q = this.pendingKycSearch.toLowerCase();
        if (!q) return this.pendingKycList;
        return this.pendingKycList.filter(x =>
          (x.BP_CODE_NEW || '').toLowerCase().includes(q) ||
          (x.BP_DSC || '').toLowerCase().includes(q)
        );
      }
    },
    methods: {
      pageload() {
        startReq();
        var vm = this;
        vm.tablesWait = true;
        axios.post('/api/UICapi/pageLoadKycDashboard')
          .then(function (res) {
            endReq();
            if (res.data.status) {
              vm.clients = res.data.clients;
              vm.individual = res.data.individual;
              vm.corporate = res.data.corporate;
              vm.pendingkyc = res.data.pendingkyc;
              vm.expireddirector = res.data.expireddirector;
              //vm.expiredbenificiary = res.data.expiredbenificiary;
              vm.expiredindividual = res.data.expiredindividual;
              //vm.pending_verification = res.data.pending_verification;
              vm.corporateCRP = res.data.corporateCRP;
              vm.individualCRP = res.data.individualCRP;
              vm.riskCounts = res.data.riskCounts;
              vm.tablesWait = false;
            }
          })
      },
      openPendingKyc() {
        this.pendingKycSearch = '';
        this.pendingKycList = [];
        this.pendingKycLoading = true;
        if (this.pendingKycModalInstance) {
          this.pendingKycModalInstance.show();
        } else {
          $('#pendingKycModal').modal('show');
        }
        startReq();
        axios.get('/api/UICapi/loadPendingKycClients')
          .then(res => {
            endReq();
            this.pendingKycLoading = false;
            if (res.data.status) {
              this.pendingKycList = res.data.list || [];
            } else {
              toastr.error(res.data.msg);
            }
          })
          .catch(err => {
            endReq();
            this.pendingKycLoading = false;
            console.error(err);
            toastr.error('Error loading pending KYC clients.');
          });
      },
      closePendingKyc() {
        if (this.pendingKycModalInstance) {
          this.pendingKycModalInstance.hide();
        } else {
          $('#pendingKycModal').modal('hide');
        }
      },
      getClientType(ptrId) {
        return ptrId === 1 ? 'Individual' : ptrId === 2 ? 'Corporate' : '';
      },
      formatDate(date) {
        return date ? String(date).split('T')[0] : '';
      },
      redirectClients(PTR_ID) {
        let url = PTR_ID === 0
          ? '../UIC/BasicClientProfileList'
          : '../UIC/BasicClientProfileList?PTR_ID=' + PTR_ID;
        window.open(url, '_blank');
      },
      redirectClientsReport(type) {
        let url = '../UIC/ClientReport?';

        if (type === 'director') {
          url += 'Director=1'; // Expired Director
        }
        else if (type === 'individual') {
          url += 'Individual=1'; // Expired Individual
        }
        else if (type === 'verification') {
          url += 'Verification=2'; // Pending (UnVerified)
        }

        window.open(url, '_blank');
      },
      redirectAdvanceSearch() {
        window.open('../UIC/ClientAdvanceSearch', '_blank');
      },
      redirectMatchingBulkClient() {
        window.open('../UIC/MatchingBulkClient', '_blank');
      },
      redirectBlockAccountClient() {
        window.open('../UIC/BlockAccountsClientList', '_blank');
      },
      openfilter() {
        $('#dateFilter').modal('show');
      },
      checkDate() {
        const from = this.filter.DateFrom;
        const to = this.filter.DateTo;

        if (from && to && from > to) {
          toastr.warning('Date From cannot be later than Date To.');
        }
      },
      applyDateFilter() {
        const from = this.filter.DateFrom;
        const to = this.filter.DateTo;

        if (from && to && from > to) {
          toastr.warning('Date From cannot be later than Date To.');
          return;
        }
        $('#dateFilter').modal('hide');
        this.pageload();
      },
    }
  })</script>

<style scoped>
  .myhover:hover {
    background-color: lightgray;
    cursor: pointer,
  }

  .left-margin {
    padding-left: 50px !important;
  }

  .sub-total {
    border-top: 1px solid black;
    font-style: italic;
  }

  .sub-top {
    margin-top: 10px;
  }

  .debit-credit {
    width: 200px !important;
  }

  .balance-sheet-line-height {
    line-height: 0px;
    font-size: 12px;
  }
</style>



// WEBPACK FOOTER //
// src/components/ims/KycDashboard.vue